import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Target, Flame, Clock, Users2, ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const ICONS = { lead: Users2, intent: Flame, followup: Clock, audience: Target };

export default function AdminOpportunities() {
  const { data } = useQuery({ queryKey: ["admin-opportunities"], queryFn: async () => (await api.get("/admin/opportunities")).data });

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Opportunity Center</h1>
      <p className="text-sm text-muted-foreground">Legitimate opportunities from your own data, no scraping, no fake leads.</p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {(data?.summary || []).map((s) => {
          const Ic = ICONS[s.kind] || Target;
          return (
            <div key={s.label} className="bs-card p-5" data-testid={`opp-${s.kind}`}>
              <Ic className="h-5 w-5 text-primary" />
              <p className="mt-3 font-display text-3xl font-black">{s.value}</p>
              <p className="text-xs text-muted-foreground">{s.label}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="bs-card p-5">
          <h2 className="font-display font-bold">High-intent enquiries</h2>
          <div className="mt-3 space-y-2">
            {(data?.high_intent || []).map((l) => (
              <div key={l.id} className="flex items-center justify-between rounded-lg border border-border p-3 text-sm">
                <div><span className="font-semibold">{l.name}</span><span className="text-muted-foreground"> · {l.service || l.type}</span></div>
                <Badge variant="outline">{l.type}</Badge>
              </div>
            ))}
            {(data?.high_intent || []).length === 0 && <p className="text-sm text-muted-foreground">None right now.</p>}
          </div>
        </div>
        <div className="bs-card p-5">
          <h2 className="font-display font-bold">Follow-up opportunities</h2>
          <div className="mt-3 space-y-2">
            {(data?.follow_ups || []).map((l) => (
              <div key={l.id} className="flex items-center justify-between rounded-lg border border-border p-3 text-sm">
                <div><span className="font-semibold">{l.name}</span><span className="text-muted-foreground"> · {l.email}</span></div>
                <Badge variant="secondary">{l.status}</Badge>
              </div>
            ))}
            {(data?.follow_ups || []).length === 0 && <p className="text-sm text-muted-foreground">Nothing to follow up.</p>}
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-start gap-3 rounded-xl border border-border bg-card/40 p-5">
        <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-success" />
        <p className="text-sm text-muted-foreground">{data?.note}</p>
      </div>

      <div className="mt-4"><Link to="/admin/leads" className="text-sm font-semibold text-primary">Manage all leads →</Link></div>
    </div>
  );
}
